import Link from "next/link";
import styles from "./post.module.scss";
const Post = ({ title, coverImage, excerpt, slug, category }) => {
	return (
		<div className={styles.main}>
			<div className={styles.main__left}>
				<a href={category ? `/blog/${category}/${slug}` : `/blog/${slug}`}>
					<a>
						<h2>{title}</h2>
					</a>
				</a>

				<a href={category ? `/blog/${category}/${slug}` : `/blog/${slug}`}>
					<a>
						<p className={styles.description}>{excerpt}</p>
					</a>
				</a>
				<a href={category ? `/blog/${category}/${slug}` : `/blog/${slug}`}>
					<a>
						<button className={styles.button}>Continue Reading</button>
					</a>
				</a>
			</div>

			<div className={styles.main__right}>
				<a href={category ? `/blog/${category}/${slug}` : `/blog/${slug}`}>
					<a>
						<img
							src={coverImage}
							width='auto'
							height='300px'
							className={styles.postCover}
						/>
					</a>
				</a>
			</div>
		</div>
	);
};

export default Post;
